import { render, staticRenderFns } from "./EditCategoryLoader.vue?vue&type=template&id=d9183d08"
import script from "./EditCategoryLoader.vue?vue&type=script&lang=ts"
export * from "./EditCategoryLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports